import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

function BusinessDetailsBaseInfo({ ownerType, editActive, person = {}, renderSnippet }) {
  let {
    first_name,
    middle_name,
    last_name,
    alternative_names,
    title,
    dob,
    getdob,
    birth_place,
    nationality,
    ownership_percentage,
    phone,
    email,
    updateForSave,
  } = person;
  const isProprietor = ownerType === 'business proprietor or officer';

  dob = getdob || dob;

  return (
    <>
      {renderSnippet({
        title: 'First Name',
        content: first_name,
        editActive: editActive,
        onChange: (e) => updateForSave('first_name', e.target.value),
        tooltipContent: `First name of ${ownerType}.`,
      })}
      {renderSnippet({
        title: 'Middle Name',
        content: middle_name,
        editActive: editActive,
        onChange: (e) => updateForSave('middle_name', e.target.value),
        tooltipContent: `Middle name of ${ownerType}.`,
      })}
      {renderSnippet({
        title: 'Last Name',
        content: last_name,
        editActive: editActive,
        onChange: (e) => updateForSave('last_name', e.target.value),
        tooltipContent: `Last name of ${ownerType}.`,
      })}
      {renderSnippet({
        title: 'Date Of Birth',
        content: dob,
        editActive: editActive,
        onChange: (e) => {
          updateForSave('dob', e.target.value);
          if (!isProprietor) {
            // if not proprietor, update getdob as well
            updateForSave('getdob', e.target.value);
          }
        },
        tooltipContent: `Date of birth of ${ownerType}.`,
      })}
      {renderSnippet({
        title: 'Birth Place',
        content: birth_place,
        editActive: editActive,
        onChange: (e) => updateForSave('birth_place', e.target.value),
        tooltipContent: `Birth place of ${ownerType}.`,
      })}
      {renderSnippet({
        title: 'Nationality',
        content: nationality,
        editActive: editActive,
        onChange: (e) => updateForSave('nationality', e.target.value),
        tooltipContent: `Nationality of ${ownerType}.`,
      })}
      {renderSnippet({
        title: 'Phone',
        content: phone,
        editActive: editActive,
        onChange: (e) => updateForSave('phone', e.target.value),
        tooltipContent: `Telephone number of ${ownerType}.`,
      })}
      {renderSnippet({
        title: 'Email',
        content: email,
        editActive: editActive,
        onChange: (e) => updateForSave('email', e.target.value),
        tooltipContent: `Email address of ${ownerType}.`,
      })}
      {isProprietor &&
        renderSnippet({
          title: 'Alternative Names',
          content: alternative_names,
          editActive: editActive,
          onChange: (e) => updateForSave('alternative_names', e.target.value),
          tooltipContent: `Alternate names of ${ownerType}.`,
        })}
      {renderSnippet({
        title: 'Title',
        content: title,
        editActive: editActive,
        onChange: (e) => updateForSave('title', e.target.value),
        tooltipContent: `Title of ${ownerType}.`,
      })}
      {!isProprietor &&
        renderSnippet({
          title: 'Ownership Percentage',
          content: ownership_percentage,
          editActive: editActive,
          onChange: (e) => updateForSave('ownership_percentage', e.target.value),
          tooltipContent: `Ownership percentage of ${ownerType}.`,
        })}
    </>
  );
}

BusinessDetailsBaseInfo.propTypes = {
  ownerType: PropTypes.string,
  editActive: PropTypes.bool,
  person: PropTypes.shape({
    first_name: PropTypes.string,
    middle_name: PropTypes.string,
    last_name: PropTypes.string,
    alternative_names: PropTypes.string,
    title: PropTypes.string,
    dob: PropTypes.string,
    getdob: PropTypes.string,
    birth_place: PropTypes.string,
    nationality: PropTypes.string,
    ownership_percentage: PropTypes.string,
    phone: PropTypes.string,
    ssn: PropTypes.string,
    email: PropTypes.string,
  }),
  renderSnippet: PropTypes.func,
};

BusinessDetailsBaseInfo.defaultProps = {
  editActive: false,
  person: {},
};

export default observer(BusinessDetailsBaseInfo);
